require('./hireOpenYoungSummary.scss');

// @ vendors
const PropTypes = require('prop-types');
const React = require('react');

// @ helpers
const { FormattedText } = require('core/i18n').i18n;

class HireOpenYoungSummary extends React.Component {

    render() {
        const { 
            asociatedAccount,
            legalRepresentative,
            name,
            shippingAddress,
        } = this.props;

        let legalRepresentativeContent;

        if (!!legalRepresentative) {
            legalRepresentativeContent = (
                <div className="col-xs-5">
                    <FormattedText
                        className="hire-open-young-summary__label"
                        value="hireOpenYoungSummary-hireOpenYoungSummary_legalRepresentative"
                    />
                    <div className="hire-open-young-summary__value">
                        {legalRepresentative}
                    </div>
                </div>
            );
        }

        return (
            <div>
                <div className="hire-open-young-summary row">      
                    <div className="col-xs-4">
                        <FormattedText
                            className="hire-open-young-summary__label"
                            value="hireOpenYoungSummary-hireOpenYoungSummary_name"
                        />
                        <div className="hire-open-young-summary__value">
                            {name}
                        </div>
                    </div>
                    <div className="col-xs-5">
                        <FormattedText
                            className="hire-open-young-summary__label"
                            value="hireOpenYoungSummary-hireOpenYoungSummary_shippingAddress"
                        />
                        <div className="hire-open-young-summary__value">
                            {shippingAddress}
                        </div>
                    </div>
                </div>
                <div className="hire-open-young-summary row">
                    <div className="col-xs-4">
                        <FormattedText
                            className="hire-open-young-summary__label"
                            value="hireOpenYoungSummary-hireOpenYoungSummary_asociatedAccount"
                        />
                        <div className="hire-open-young-summary__value">
                            {asociatedAccount}
                        </div>
                    </div>
                    {legalRepresentativeContent}
                </div>
            </div>
        );
    }
}

HireOpenYoungSummary.propTypes = {
    asociatedAccount: PropTypes.object.isRequired,
    legalRepresentative: PropTypes.object.isRequired,
    name: PropTypes.string.isRequired,
    shippingAddress: PropTypes.string.isRequired
};

module.exports = HireOpenYoungSummary;
